import { Fragment, ReactNode } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { UnicodeEntity } from '@mews/enums';
import { SearchItemDescriptionPrefix, SearchItemDescriptionSeparator, SearchItemDescriptionValue } from './styles';

export interface DescriptionItem {
    value: string | ReactNode;
    prefix?: string | ReactNode | undefined;
    suffix?: string | ReactNode | undefined;
}

interface SearchItemDescriptionProps {
    descriptions: DescriptionItem[];
}

export const SearchItemDescription = ({ descriptions }: SearchItemDescriptionProps) => (
    <Fragment>
        {descriptions.map(({ prefix, value, suffix }, index) => {
            const prefixChecked = prefix || '';
            const suffixChecked = suffix || '';
            const valueChecked = value || '';
            const prefixHash =
                typeof prefixChecked !== 'string'
                    ? renderToStaticMarkup(assertComponentType(prefixChecked))
                    : prefixChecked;
            const valueHash =
                typeof value !== 'string' ? renderToStaticMarkup(assertComponentType(valueChecked)) : value;
            const suffixHash =
                typeof suffix !== 'string' ? renderToStaticMarkup(assertComponentType(suffixChecked)) : suffix;

            const buildKey = `${prefixHash}-${valueHash}-${suffixHash}`;
            return (
                <Fragment key={buildKey}>
                    {prefix && <AdditionalText text={prefix} />}
                    <SearchItemDescriptionValue>{value}</SearchItemDescriptionValue>
                    {suffix && <AdditionalText text={suffix} isSuffix />}
                    {index !== descriptions.length - 1 && <Separator />}
                </Fragment>
            );
        })}
    </Fragment>
);

const assertComponentType = (component: {}) => component as React.ReactElement;

interface AdditionalTextProps {
    text: string | ReactNode;
    isSuffix?: boolean;
}

const AdditionalText = ({ text, isSuffix }: AdditionalTextProps) => (
    <span>
        {isSuffix && UnicodeEntity.Space}
        <SearchItemDescriptionPrefix>{text}</SearchItemDescriptionPrefix>
        {!isSuffix && UnicodeEntity.Space}
    </span>
);

const Separator = () => (
    <span>
        {UnicodeEntity.Space}
        <SearchItemDescriptionSeparator>{UnicodeEntity.ForwardSlash}</SearchItemDescriptionSeparator>
        {UnicodeEntity.Space}
    </span>
);
